import { getPublicAssetUrl } from './publicAssets';

const SHOP_IMAGE_FOLDERS: Record<number, string> = {
    2: 'Villalba',
    3: 'Alcobendas',
    5: 'Rozas',
    7: 'Leganes',
};

export function getShopImageFolderName(shopId: number, shopName?: string): string | null {
    const folderById = SHOP_IMAGE_FOLDERS[shopId];
    if (folderById) {
        return folderById;
    }

    const normalized = shopName?.toLowerCase() ?? '';
    if (normalized.includes('villalba')) return 'Villalba';
    if (normalized.includes('alcobendas') || normalized.includes('sanse')) return 'Alcobendas';
    if (normalized.includes('rozas')) return 'Rozas';
    if (normalized.includes('legan')) return 'Leganes';

    return null;
}

export function getRoomImageUrl(shopId: number, roomNum: number, shopName?: string): string | null {
    const folderName = getShopImageFolderName(shopId, shopName);
    if (!folderName) {
        return null;
    }

    return getPublicAssetUrl(`img/rooms/${folderName}/${roomNum}.jpg`);
}

export function getShopFacadeImageUrl(shopId: number, shopName?: string): string | null {
    const folderName = getShopImageFolderName(shopId, shopName);
    if (!folderName) {
        return null;
    }

    return getPublicAssetUrl(`img/facade/${folderName}/Fachada${folderName}.webp`);
}
